// @ts-nocheck
const BRIDGE_ACTIONS = {
  SET_API_IS_INITIALIZED: 'SET_API_IS_INITIALIZED',
  SET_IS_API_DISCONNECTED: 'SET_IS_API_DISCONNECTED',
  SET_SELECTED_ASSET_TYPE: 'SET_SELECTED_ASSET_TYPE',
  SET_SENDER_ASSET_CURRENT_BALANCE: 'SET_SENDER_ASSET_CURRENT_BALANCE',
  SET_FEE_ESTIMATES: 'SET_FEE_ESTIMATES',
  SET_SENDER_ASSET_TARGET_BALANCE: 'SET_SENDER_ASSET_TARGET_BALANCE',
  SET_SENDER_SUBSTRATE_ACCOUNT: 'SET_SENDER_SUBSTRATE_ACCOUNT',
  SET_SENDER_SUBSTRATE_ACCOUNT_OPTIONS: 'SET_SENDER_PUBLIC_ACCOUNT_OPTIONS',
  SET_ORIGIN_CHAIN: 'SET_ORIGIN_CHAIN',
  SET_DESTINATION_CHAIN: 'SET_DESTINATION_CHAIN',
  SET_DESTINATION_ADDRESS: 'SET_DESTINATION_ADDRESS',
  SET_BRIDGE: 'SET_BRIDGE',
  SWITCH_ORIGIN_AND_DESTINATION: 'SWITCH_ORIGIN_AND_DESTINATION',
  SET_SENDER_NATIVE_ASSET_CURRENT_BALANCE: 'SET_SENDER_NATIVE_ASSET_CURRENT_BALANCE'
};

export default BRIDGE_ACTIONS;
